import React, { ReactNode } from 'react';

interface FieldIconProps {
  icon: ReactNode;
  onClick?: () => void;
}

const FieldIcon = ({ icon, onClick, ...props }: FieldIconProps) => (
  <button
    type="button"
    tabIndex={0}
    onKeyDown={e => {
      if (e.code !== 'Tab') e.preventDefault();
      onClick && onClick();
    }}
    onClick={onClick}
    className="absolute right-2.5 top-1/2 -translate-y-1/2 w-[20px] h-[20px] cursor-pointer peer-autofill:[&>svg]:text-black focus:border-[1px]"
    {...props}
  >
    {icon}
  </button>
);

export default FieldIcon;
